import { connect } from 'react-redux';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getSearchSuggestions } from '../../../../shared/actions/constructor-autosuggest';
import {
  openModalAndLayer,
  closeModalAndLayer,
} from '../../../../shared/actions/masthead/header';
import Autosuggest from '../../global/header/Autosuggest';
import { NUMBER_OF_RECOMMENDED_ITEMS } from '../../constants.js';

const AutosuggestContainer = ({
  fetchSuggestedProducts,
  openModal,
  closeModal,
  searchTerm,
  searchSuggestions,
  showSuggest,
  locale,
  isDesktop,
  setDebounceVal,
  layer,
}) => {
  const autoSuggestRef = useRef(null);
  const handleEscapeKey = e => {
    if (e.key === 'Escape') {
      closeModal('modal');
      setDebounceVal('');
    }
  };

  useEffect(() => {
    const autoSuggest = autoSuggestRef.current;
    if (autoSuggest) {
      autoSuggest.addEventListener('keydown', handleEscapeKey);
    }
    return () => {
      if (autoSuggest) {
        autoSuggest.removeEventListener('keydown', handleEscapeKey);
      }
    };
  }, []);

  useEffect(() => {
    if (!searchTerm) return;
    fetchSuggestedProducts(searchTerm);
    if (isDesktop) {
      openModal('modal');
    }
  }, [searchTerm]);

  const closeAutoSuggest = () => {
    if (isDesktop) {
      closeModal();
      setDebounceVal('');
    }
  };
  const sliceAmount = isDesktop ? 4 : 3;
  const suggestedProducts =
    searchSuggestions?.searchSuggestions?.sections?.['Products'] || [];

  const productSuggestions = suggestedProducts
    ?.slice(0, sliceAmount)
    .map(product => ({
      ...product,
      data: {
        ...product?.data,
        images: {
          listing: {
            src: product?.data?.['image_url'],
            alt: product?.value,
          },
        },
        pricing: {
          price: product?.data?.price,
          originalPrice: product?.data?.originalPrice,
        },
        attributes: {},
      },
    }));

  const suggestedSearch =
    searchSuggestions?.searchSuggestions?.sections?.['Search Suggestions'];

  return (
    <>
      <div ref={autoSuggestRef}>
        {suggestedProducts?.length > 0 &&
          suggestedSearch?.length > 0 &&
          showSuggest &&
          (!isDesktop || layer.modifiers?.[0] === 'autosuggest') &&
          layer.isVisible && (
            <Autosuggest
              productSuggestions={productSuggestions}
              suggestedSearch={suggestedSearch}
              locale={locale}
              isDesktop={isDesktop}
              onClose={closeAutoSuggest}
              showSuggest={showSuggest}
              searchTerm={searchTerm}
            />
          )}
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    searchSuggestions: state.searchSuggestions,
    locale: state.app.locale.selected,
    isDesktop: state.browser.deviceIs.desktop,
    layer: state.layer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSuggestedProducts: searchTerm =>
      dispatch(getSearchSuggestions(searchTerm, NUMBER_OF_RECOMMENDED_ITEMS)),
    openModal: () => dispatch(openModalAndLayer('modal')),
    closeModal: () => dispatch(closeModalAndLayer('modal')),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutosuggestContainer);

AutosuggestContainer.propTypes = {
  searchTerm: PropTypes.string,
  fetchSuggestedProducts: PropTypes.func,
  searchSuggestions: PropTypes.object,
  showSuggest: PropTypes.bool,
  locale: PropTypes.string,
  isDesktop: PropTypes.bool,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  setDebounceVal: PropTypes.func,
  layer: PropTypes.object,
};

AutosuggestContainer.defaultProps = {
  searchTerm: '',
  showSuggest: false,
};
